// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".get-a-node-widget[data-v-5314e457] :not(.background-check-svg){z-index:1}.background-check[data-v-5314e457]{opacity:.61;top:0;left:0;bottom:0;right:0;position:absolute;overflow:hidden;border-bottom-left-radius:4px}.background-check svg[data-v-5314e457]{height:280%;position:absolute;top:-10%;left:-2px;transform:scaleY(-1)}.get-a-node-laptop[data-v-5314e457]{width:35%}.gala-btn[data-v-5314e457]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
